<template>
  <div>
    <base-card>
      <v-card-title>
        <span v-t="apartment.title" class="mr-1" />
        <span>{{ apartment.number }}</span>
      </v-card-title>
      <v-card-text>
        <div class="mb-2">
          <span>{{ apartment.floor + $t(". floor") }}</span>
          <span class="mx-2">|</span>
          <span>{{ $t("{0} rooms", [apartment.rooms]) }}</span>
          <span class="mx-2">|</span>
          <span>{{ apartment.area }} m²</span>
        </div>
        <div class="mb-2">
          <v-dialog width="1000">
            <template v-slot:activator="{ on }">
              <base-card max-width="400" max-height="400">
                <v-img class="cursor-pointer" v-on="on" :src="apartment.floor_plan"></v-img>
              </base-card>
            </template>
            <base-card outlined>
              <v-img
                contain
                :src="apartment.floor_plan"
                aspect-ratio="1"
                max-height="500px"
              ></v-img>
            </base-card>
          </v-dialog>
        </div>
        <div class="mb-2">
          <span v-t="'Rooms:'" />

          <span>
            {{ apartment.room_sizes.map((el) => el + " m²").join(", ") }}
          </span>
        </div>
        <div
          class="mb-2"
          v-if="Array.isArray(apartment.bathrooms) && apartment.bathrooms.length > 0"
        >
          <span v-t="'Bathrooms:'" />
          :
          <span>
            {{ apartment.bathrooms.map((el) => el + " m²").join(", ") }}
          </span>
        </div>
        <base-card v-if="selections.length > 0" outlined>
          <v-card-title>
            <span v-t="'Client\'s preferences'" />
          </v-card-title>
          <v-simple-table>
            <thead>
              <tr>
                <th><span v-t="'Email'" /></th>
                <th><span v-t="'Tel'" /></th>
                <th><span v-t="'Created at'" /></th>
                <th><span v-t="'Updated at'" /></th>
                <th><span v-t="'Status'" /></th>
                <th><span v-t="'Price'" /></th>
                <th><span v-t="'Actions'" /></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="selection in selections" :key="'selection' + selection.id">
                <td>{{ selection.email }}</td>
                <td>{{ selection.tel }}</td>
                <td>{{ selection.created_at }}</td>
                <td>{{ selection.updated_at }}</td>
                <td>{{ selection.status }}</td>
                <td>{{ selection.final_price }}</td>
                <td>
                  <a :href="selection.pdf" target="_blank" title="Show pdf" class="mx-1">
                    <v-icon>mdi-file-pdf-box</v-icon>
                  </a>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </base-card>
      </v-card-text>
    </base-card>
  </div>
</template>

<script>
export default {
  created() {
    this.fetchSelections();
  },
  data() {
    return {
      loadingSelections: false,
      selections: [],
    };
  },
  computed: {
    apartment() {
      return this.$store.state.apartments.find(
        (item) => parseInt(item.id) === parseInt(this.$route.params.id),
      );
    },
  },
  methods: {
    async fetchSelections() {
      this.loadingSelections = true;
      try {
        const response = await this.axios.get(`apartment/${this.apartment.id}/selections`);
        this.selections = response.data;
      } catch (error) {
      } finally {
        this.loadingSelections = false;
      }
    },
  },
};
</script>

<style>
</style>
